import React from "react";
import { Link } from "react-router-dom";
import ThemeToggleButton from "./ThemeToggleButton";

const ScoutLocalNavbar = () => {
  const logout = () => {
    localStorage.removeItem("token");
    // window.location.href = "login";
  };

  return (
    <div className="navbar fixed top-0 mx-auto shadow-xl bg-base-200 z-10 mb-12">
      <div className="navbar-center ">
        {/* <button onClick={logout} className="btn">
          Logout
        </button> */}
        {/* <Link to="/admin" className="btn">
          Fotos
        </Link>
        <Link to="/admin/atletas" className="btn">
          Atletas
        </Link>
        <Link to="/admin/compras/aprovar" className="btn">
          Aprovações
        </Link>
        <Link to="/ar/home" className="btn">
          Loja
        </Link> */}
        <Link to="/" onClick={logout} className="btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="32px"
            width="32px"
            viewBox="0 -960 960 960"
            fill="#000000"
          >
            <path d="M202.57-140q-25.79 0-44.18-18.39T140-202.57v-554.86q0-25.79 18.39-44.18T202.57-820h277.4v50.26h-277.4q-4.62 0-8.47 3.84-3.84 3.85-3.84 8.47v554.86q0 4.62 3.84 8.47 3.85 3.84 8.47 3.84h277.4V-140h-277.4Zm459.38-181.54-35.85-35.95 97.39-97.38H363.85v-50.26h358.82l-97.39-97.38 35.59-36.21L820-479.46 661.95-321.54Z" />
          </svg>
        </Link>
        <Link to="/admin/athletes" className="btn">
          Athletes
        </Link>
        <Link to="/admin/teams" className="btn">
          Teams
        </Link>
        <Link to="/admin/games" className="btn">
          Games
        </Link>
      </div>

      <div className="navbar-end">
        <ThemeToggleButton />
      </div>
    </div>
  );
};

export default ScoutLocalNavbar;
